<style scoped>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 16px;
  }

  .image {
    width: 100%;
    max-width: fit-content;
  }

  .image img {
    max-width: 100%;
    max-height: 90vh;
    height: auto;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .content span, .content a {
    margin: 10px 0;
  }

  .name {
    font-size: 0.9rem;
    color:rgba(0, 0, 0, .6);
  }

  .title {
    font-size: 3rem;
    font-weight: 500;
    font-family: 'rosita', Helvetica, Arial, sans-serif;
    text-transform: none;
  }

  .description {
    color: rgba(0, 0, 0, .8);
    font-weight: 700;
    font-size: 1rem;
    text-transform: none;
  }

  a {
    background-color: rgb(0, 0, 0);
    color: rgba(255, 255, 255, 1);
    padding: 10px 20px;
    font-size: 0.9rem;
  }

  .content-text {
    display: flex;
    flex-direction: column;
    padding: 0 32px;
    justify-content: center;
    align-items: center;
  }

  @media (min-width: 610px) {
    .container {
      flex-direction: row;
      justify-content: space-between;
      flex-grow: 1;
      flex-basis: 0;
    }

    .reversed {
      flex-direction: row-reverse;
    }

    .image, .content {
      padding: 16px;
    }

    .content-text {
      max-width: 700px;
    }
  }
</style>
<template>
  <div class="container" :class="{reversed: imageReverse}">
    <section class="image">
      <picture>
        <source v-for="image in image.sources" v-bind:key="image.default" :srcset="image.src" :media="image.media">
        <img :alt="title" :src="image.default">
      </picture>
    </section>
    <section class="content">
      <div class="content-text">
        <span class="name">{{ name }}</span>
        <span class="title">{{ title }}</span>
        <span class="description">{{ description }}</span>
        <router-link :to="url">Ver más</router-link>
      </div>
    </section>
  </div>
</template>
<script>
/** IMAGES PROTOTYPE OBJECT
{
        default: '/assets/images/training/tech-skills-tracks-front-end-image-resized.jpg',
        sources: [
          {src: '/assets/images/training/tech-skills-tracks-front-end-image-resized-low.jpg', media: '(max-width: 768px)'},
          {src: '/assets/images/training/tech-skills-tracks-front-end-image-resized.jpg', media: '(min-width: 768px)'},
        ]
}

 */
export default {
  name: 'ViewSummary',
  props: {
    title: String,
    name: String,
    description: String,
    image: Object,
    url: String,
    imageReverse: {
      type: Boolean,
      default: false
    }
  }
}
</script>
